import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Main } from '../../components'
import { usePageInfo } from '../../config/queries'
import { useGlobalNewsItems } from '../../config/queries'
import SupportPageHeader from '../Support/SupportPageHeader'
import NewsSidebar from './NewsSidebar'

const NewsLayout = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation()
  const { data: items, isPending } = useGlobalNewsItems()
  const {
    data: { user },
  } = usePageInfo()
  const canManage = !!user?.superAdmin

  return (
    <Main
      title={t('news.landing-title')}
      description={t('news.landing-description')}
    >
      <SupportPageHeader
        title={t('news.landing-title')}
        description={t('news.landing-description')}
        className='mb-4 lg:mb-10'
      />

      <div className='flex flex-col lg:flex-row gap-4 lg:gap-12'>
        <NewsSidebar
          items={items ?? []}
          canManage={canManage}
          isLoading={isPending}
        />
        <div className='min-w-0 flex-1'>{children}</div>
      </div>
    </Main>
  )
}

export default NewsLayout
